(() => {
  const ROOT_SELECTOR = '[data-ae-gifts]';

  const setupCarousel = (root) => {
    const carousel = root.querySelector('[data-carousel]');
    if (!carousel || carousel.dataset.carouselReady === 'true') return;

    const rail = carousel.querySelector('[data-carousel-rail]');
    const cards = [...carousel.querySelectorAll('[data-carousel-card]')];
    const previous = carousel.querySelector('[data-carousel-previous]');
    const next = carousel.querySelector('[data-carousel-next]');
    const dots = carousel.querySelector('[data-carousel-dots]');
    if (!rail || !cards.length || !previous || !next || !dots) return;

    carousel.dataset.carouselReady = 'true';
    let dotButtons = [];
    let frame = 0;

    const maximumScroll = () => Math.max(0, rail.scrollWidth - rail.clientWidth);

    const cardStep = () => {
      if (cards.length < 2) return cards[0].getBoundingClientRect().width;
      return Math.abs(cards[1].offsetLeft - cards[0].offsetLeft);
    };

    const updateState = () => {
      frame = 0;
      const maxScroll = maximumScroll();
      const current = Math.max(0, rail.scrollLeft);
      previous.disabled = current <= 2;
      next.disabled = current >= maxScroll - 2;

      const activeIndex = maxScroll > 0 && dotButtons.length > 1
        ? Math.round((current / maxScroll) * (dotButtons.length - 1))
        : 0;

      dotButtons.forEach((dot, index) => {
        const active = index === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const queueStateUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(updateState);
    };

    const buildDots = () => {
      const maxScroll = maximumScroll();
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const maximumDots = isMobile ? 6 : 8;
      const unit = isMobile ? cardStep() : Math.max(cardStep(), rail.clientWidth * 0.52);
      const count = maxScroll > 2
        ? Math.min(maximumDots, Math.ceil(maxScroll / Math.max(1, unit)) + 1)
        : 1;

      if (count === dotButtons.length) {
        updateState();
        return;
      }

      dots.replaceChildren();
      dotButtons = Array.from({ length: count }, (_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ae-gifts__dot';
        dot.setAttribute('aria-label', `Go to category group ${index + 1} of ${count}`);
        dot.addEventListener('click', () => {
          const target = count > 1 ? (maximumScroll() * index) / (count - 1) : 0;
          rail.scrollTo({ left: target, behavior: 'smooth' });
        });
        dots.appendChild(dot);
        return dot;
      });

      updateState();
    };

    const scrollByPage = (direction) => {
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      const distance = isMobile ? cardStep() : Math.max(cardStep(), rail.clientWidth * 0.72);
      rail.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollByPage(-1));
    next.addEventListener('click', () => scrollByPage(1));
    rail.addEventListener('scroll', queueStateUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(buildDots);
      observer.observe(rail);
    } else {
      window.addEventListener('resize', buildDots, { passive: true });
    }

    buildDots();
  };

  const setupFeaturedProduct = (root) => {
    const featured = root.querySelector('[data-featured-product]');
    if (!featured || featured.dataset.productReady === 'true') return;

    const swatches = [...featured.querySelectorAll('[data-variant-swatch]')];
    const variantInput = featured.querySelector('[data-variant-input]');
    const variantLink = featured.querySelector('[data-variant-link]');
    const price = featured.querySelector('[data-featured-price]');
    const image = featured.querySelector('[data-featured-image]');
    if (!swatches.length || (!variantInput && !variantLink)) return;

    featured.dataset.productReady = 'true';

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        if (swatch.disabled) return;

        if (variantInput) variantInput.value = swatch.dataset.variantId;
        if (variantLink) variantLink.href = variantLink.dataset.productUrl + '?variant=' + swatch.dataset.variantId;
        if (price && swatch.dataset.variantPrice) {
          price.textContent = swatch.dataset.variantPrice;
        }
        if (image && swatch.dataset.variantImage) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = swatch.dataset.variantImage;
          image.alt = swatch.getAttribute('aria-label') || image.alt;
        }

        swatches.forEach((item) => {
          const selected = item === swatch;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      });
    });
  };

  const setup = (scope = document) => {
    const roots = scope.matches?.(ROOT_SELECTOR)
      ? [scope]
      : [...scope.querySelectorAll(ROOT_SELECTOR)];

    roots.forEach((root) => {
      if (window.matchMedia('(min-width: 769px)').matches) setupCarousel(root);
      setupFeaturedProduct(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup());
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
